// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__18MGm","head":"ProcedureTableInfo_head__3wkGZ"};